import http from "@/helper/http";
import api from "@/helper/api";

const defaultSuppliers = () => ({ items: [], total: 0, page: 1, pages: 0 });

export default {
  state: {
    suppliers: defaultSuppliers(),
    loadingSuppliers: false,
    loadingCreateSupplier: false,
    loadingUpdateSupplier: false,
    loadingDeleteSupplier: false,
  },
  mutations: {
    SET_SUPPLIERS(state, suppliers) {
      state.suppliers = suppliers || defaultSuppliers();
    },
    SET_LOADING_SUPPLIERS(state, value) {
      state.loadingSuppliers = !!value;
    },
    SET_LOADING_CREATE_SUPPLIER(state, value) {
      state.loadingCreateSupplier = !!value;
    },
    SET_LOADING_UPDATE_SUPPLIER(state, value) {
      state.loadingUpdateSupplier = !!value;
    },
    SET_LOADING_DELETE_SUPPLIER(state, value) {
      state.loadingDeleteSupplier = !!value;
    },
    RESET_SUPPLIERS_STATE(state) {
      state.suppliers = defaultSuppliers();
    },
  },
  actions: {
    async listSuppliers(
      { commit },
      { storeId, page = 1, per_page = 10, query = "", include_inactive = false }
    ) {
      if (!storeId) {
        commit("RESET_SUPPLIERS_STATE");
        throw new Error("A storeId is required to list suppliers");
      }

      commit("RESET_SUPPLIERS_STATE");
      commit("SET_LOADING_SUPPLIERS", true);
      try {
        const { data } = await http.get(api.purchase_suppliers(storeId), {
          params: { page, per_page, query, include_inactive },
        });
        commit("SET_SUPPLIERS", data);
        return data;
      } catch (error) {
        commit("RESET_SUPPLIERS_STATE");
        throw error;
      } finally {
        commit("SET_LOADING_SUPPLIERS", false);
      }
    },
    async createSupplier({ commit }, { storeId, payload }) {
      commit("SET_LOADING_CREATE_SUPPLIER", true);
      try {
        const { data } = await http.post(api.purchase_suppliers(storeId), payload);
        return data;
      } finally {
        commit("SET_LOADING_CREATE_SUPPLIER", false);
      }
    },
    async updateSupplier({ commit }, { storeId, supplierId, patch }) {
      commit("SET_LOADING_UPDATE_SUPPLIER", true);
      try {
        const { data } = await http.patch(
          api.purchase_supplier(storeId, supplierId),
          patch
        );
        return data;
      } finally {
        commit("SET_LOADING_UPDATE_SUPPLIER", false);
      }
    },
    async deleteSupplier({ commit }, { storeId, supplierId }) {
      commit("SET_LOADING_DELETE_SUPPLIER", true);
      try {
        const { data } = await http.delete(
          api.purchase_supplier(storeId, supplierId)
        );
        return data;
      } finally {
        commit("SET_LOADING_DELETE_SUPPLIER", false);
      }
    },
  },
  getters: {
    suppliers: (state) => state.suppliers,
    loadingSuppliers: (state) => state.loadingSuppliers,
    loadingCreateSupplier: (state) => state.loadingCreateSupplier,
    loadingUpdateSupplier: (state) => state.loadingUpdateSupplier,
    loadingDeleteSupplier: (state) => state.loadingDeleteSupplier,
  },
};
